import { getTaskProgressText, Mtds, useGetOwnerNameQuery } from 'prove-common'

export type TaskCardProps = {
  id: string
  ownerId: string
  samplesTaken: number
  samplesToTake: number
  countSubSamples: boolean
  isCompleted: boolean
  onClick?: (id: string) => void
}

export const TaskDelegationCard = ({
  id,
  ownerId,
  samplesTaken,
  samplesToTake,
  countSubSamples,
  isCompleted,
  onClick
}: TaskCardProps) => {
  const { data: ownerName } = useGetOwnerNameQuery(ownerId)
  const progressText = getTaskProgressText(samplesTaken, samplesToTake)

  return (
    <Mtds.Card as='button' type='button' onClick={() => onClick?.(id)}>
      <Mtds.Grid>
        <Mtds.Flex data-align='center' data-justify='space-between'>
          <strong>{ownerName?.name}</strong>
          {isCompleted && <Mtds.Tag>Ferdig</Mtds.Tag>}
        </Mtds.Flex>
        <Mtds.Flex data-align='center' data-nowrap>
          <Mtds.Progress
            data-self='100'
            value={samplesTaken}
            max={samplesToTake}
          />
          <strong data-fixed data-nowrap>
            {progressText}
          </strong>
          <p data-fixed>{countSubSamples ? 'delprøver' : 'prøveposer'}</p>
        </Mtds.Flex>
      </Mtds.Grid>
    </Mtds.Card>
  )
}
